export enum DisplayChoice {
    ReadWrite,
    ReadOnly,
    PreviewReadWrite,
    PreviewReadOnly,
    MessageOnly,
    Loading,
}
